import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CurrentWarehouseByProduct, Warehouse } from './core/product-inventory.model';

@Injectable({
  providedIn: 'root',
})
export class ProductCheckInventoryService {
  protected warehouseProducts$ = new BehaviorSubject<CurrentWarehouseByProduct[]>([]);
  protected currentWarehouse$ = new BehaviorSubject<Warehouse | undefined>(undefined);

  // Warehouse

  getWarehouse() {
    return this.currentWarehouse$.asObservable();
  }

  getWarehouseValue() {
    return this.currentWarehouse$.getValue();
  }

  setWarehouse(warehouse: Warehouse | undefined) {
    this.currentWarehouse$.next(warehouse);
  }

  // Warehouse By Product

  getWarehouseByProduct(productID: string) {
    return this.warehouseProducts$.getValue().find(item => item.productID === productID)?.warehouseID;
  }

  setWarehouseProduct(warehouseByProduct: CurrentWarehouseByProduct) {
    const items = this.warehouseProducts$.getValue();
    const indexInstance = this.warehouseProducts$
      .getValue()
      .findIndex(item => item.productID === warehouseByProduct.productID);

    if (indexInstance >= 0) {
      items[indexInstance] = warehouseByProduct;
    } else {
      items.push(warehouseByProduct);
    }

    this.warehouseProducts$.next(items);
  }
}
